import Control from "sap/m/Button";

export default Control.extend("iamsoft.libs.external.polyfill.control.MyControl",{
    metadata : {
    },
    init : function () {
    },
    renderer : {},
});
